import { userDataType } from "../../stores/accountManagementStore";

/**
 * Stores the user account data in localStorage.
 * If userData is null, it will clear the localStorage item.
 * @param {userDataType | null} userData - The user account data to store.
 */
export function storeUserAccount(userData: userDataType | null) {
    localStorage.setItem("userAccount", JSON.stringify(userData));
}


/**
 * Retrieves the user account data from localStorage.
 * If the localStorage item does not exist, it will return null.
 * @returns {userDataType | null} - The user account data, or null if it does not exist.
 */
export function  getUserAccount(): userDataType | null {
    const userAccount = localStorage.getItem("userAccount");
    return userAccount ? JSON.parse(userAccount) : null;
}
